
export const SIGNATURE_SCHEMA = {
    initialsSignaturePoints: null,
    renterSignaturePoints: null,
    svgDescription: null,
    answers: {
        answer1: null,
        answer2: null
    }
}

export const CHECKIN_SCHEMA = {
    acquirerTransactionID: "NL78JVZ4FZTQ7RT5",
    acquirerAprovedCode: "123456",
    saleData: {
        timeStamp: "2025-12-10T11:19:02.5626699-06:00"
    },
    uuidPaymentID: "5725dd1f-1901-4459-af0c-9d926e1cc970",
    cardBrand: "visa",
    signaturePoint: [
        {
            "x": "1D",
            "y": "0"
        },
        {
            "x": "1E",
            "y": "2"
        },
        {
            "x": "1D",
            "y": "2"
        },
        {
            "x": "1D",
            "y": "5"
        },
        {
            "x": "1C",
            "y": "6"
        },
        {
            "x": "1A",
            "y": "C"
        },
        {
            "x": "19",
            "y": "11"
        },
        {
            "x": "17",
            "y": "16"
        },
        {
            "x": "14",
            "y": "1C"
        },
        {
            "x": "12",
            "y": "22"
        },
        {
            "x": "F",
            "y": "29"
        },
        {
            "x": "D",
            "y": "2F"
        },
        {
            "x": "A",
            "y": "36"
        },
        {
            "x": "6",
            "y": "42"
        },
        {
            "x": "5",
            "y": "48"
        },
        {
            "x": "3",
            "y": "4D"
        },
        {
            "x": "0",
            "y": "5D"
        },
        {
            "x": "FFFF",
            "y": "FFFF"
        },
        {
            "x": "2B",
            "y": "45"
        },
        {
            "x": "2B",
            "y": "48"
        },
        {
            "x": "2A",
            "y": "48"
        },
        {
            "x": "29",
            "y": "4C"
        },
        {
            "x": "2B",
            "y": "4A"
        },
        {
            "x": "2C",
            "y": "48"
        },
        {
            "x": "2E",
            "y": "46"
        },
        {
            "x": "30",
            "y": "43"
        },
        {
            "x": "33",
            "y": "40"
        },
        {
            "x": "36",
            "y": "3C"
        },
        {
            "x": "3A",
            "y": "38"
        },
        {
            "x": "3D",
            "y": "33"
        },
        {
            "x": "46",
            "y": "2A"
        },
        {
            "x": "4A",
            "y": "25"
        },
        {
            "x": "4E",
            "y": "21"
        },
        {
            "x": "52",
            "y": "1E"
        },
        {
            "x": "55",
            "y": "1B"
        },
        {
            "x": "57",
            "y": "18"
        },
        {
            "x": "5A",
            "y": "17"
        },
        {
            "x": "5D",
            "y": "14"
        },
        {
            "x": "60",
            "y": "13"
        },
        {
            "x": "62",
            "y": "12"
        },
        {
            "x": "64",
            "y": "14"
        },
        {
            "x": "64",
            "y": "1C"
        },
        {
            "x": "63",
            "y": "1F"
        },
        {
            "x": "63",
            "y": "23"
        },
        {
            "x": "62",
            "y": "28"
        },
        {
            "x": "60",
            "y": "2C"
        },
        {
            "x": "5D",
            "y": "37"
        },
        {
            "x": "5B",
            "y": "3C"
        },
        {
            "x": "5B",
            "y": "3E"
        },
        {
            "x": "5A",
            "y": "44"
        },
        {
            "x": "5B",
            "y": "44"
        },
        {
            "x": "5B",
            "y": "43"
        },
        {
            "x": "5D",
            "y": "42"
        },
        {
            "x": "5E",
            "y": "40"
        },
        {
            "x": "61",
            "y": "3E"
        },
        {
            "x": "63",
            "y": "3B"
        },
        {
            "x": "67",
            "y": "38"
        },
        {
            "x": "70",
            "y": "2F"
        },
        {
            "x": "73",
            "y": "2D"
        },
        {
            "x": "76",
            "y": "2A"
        },
        {
            "x": "79",
            "y": "29"
        },
        {
            "x": "7B",
            "y": "27"
        },
        {
            "x": "81",
            "y": "24"
        },
        {
            "x": "85",
            "y": "24"
        },
        {
            "x": "86",
            "y": "26"
        },
        {
            "x": "86",
            "y": "2D"
        },
        {
            "x": "85",
            "y": "32"
        },
        {
            "x": "83",
            "y": "37"
        },
        {
            "x": "82",
            "y": "3D"
        },
        {
            "x": "80",
            "y": "42"
        },
        {
            "x": "7E",
            "y": "4D"
        },
        {
            "x": "7C",
            "y": "52"
        },
        {
            "x": "7A",
            "y": "5C"
        },
        {
            "x": "79",
            "y": "60"
        },
        {
            "x": "79",
            "y": "67"
        },
        {
            "x": "78",
            "y": "6A"
        },
        {
            "x": "FFFF",
            "y": "FFFF"
        },
        {
            "x": "F9",
            "y": "5"
        },
        {
            "x": "F9",
            "y": "3"
        },
        {
            "x": "F8",
            "y": "3"
        },
        {
            "x": "F8",
            "y": "5"
        },
        {
            "x": "F7",
            "y": "5"
        },
        {
            "x": "F5",
            "y": "9"
        },
        {
            "x": "F5",
            "y": "C"
        },
        {
            "x": "F4",
            "y": "F"
        },
        {
            "x": "F2",
            "y": "12"
        },
        {
            "x": "F1",
            "y": "15"
        },
        {
            "x": "EB",
            "y": "21"
        },
        {
            "x": "EA",
            "y": "26"
        },
        {
            "x": "E7",
            "y": "2A"
        },
        {
            "x": "E3",
            "y": "34"
        },
        {
            "x": "E1",
            "y": "3A"
        },
        {
            "x": "DE",
            "y": "41"
        },
        {
            "x": "DB",
            "y": "47"
        },
        {
            "x": "D9",
            "y": "4D"
        },
        {
            "x": "D6",
            "y": "53"
        },
        {
            "x": "D2",
            "y": "5D"
        },
        {
            "x": "CD",
            "y": "65"
        },
        {
            "x": "CC",
            "y": "69"
        },
        {
            "x": "C8",
            "y": "6D"
        },
        {
            "x": "C5",
            "y": "71"
        },
        {
            "x": "C3",
            "y": "71"
        },
        {
            "x": "C2",
            "y": "6E"
        },
        {
            "x": "C2",
            "y": "6A"
        },
        {
            "x": "C4",
            "y": "63"
        },
        {
            "x": "C6",
            "y": "5F"
        },
        {
            "x": "C8",
            "y": "5A"
        },
        {
            "x": "CE",
            "y": "50"
        },
        {
            "x": "D2",
            "y": "4B"
        },
        {
            "x": "D6",
            "y": "45"
        },
        {
            "x": "DE",
            "y": "3B"
        },
        {
            "x": "E3",
            "y": "37"
        },
        {
            "x": "E7",
            "y": "33"
        },
        {
            "x": "EB",
            "y": "30"
        },
        {
            "x": "EE",
            "y": "2D"
        },
        {
            "x": "F4",
            "y": "29"
        },
        {
            "x": "F8",
            "y": "27"
        },
        {
            "x": "FD",
            "y": "25"
        },
        {
            "x": "100",
            "y": "25"
        },
        {
            "x": "103",
            "y": "24"
        },
        {
            "x": "107",
            "y": "24"
        },
        {
            "x": "10B",
            "y": "26"
        },
        {
            "x": "10C",
            "y": "27"
        },
        {
            "x": "10D",
            "y": "2A"
        },
        {
            "x": "10D",
            "y": "31"
        },
        {
            "x": "109",
            "y": "3D"
        },
        {
            "x": "106",
            "y": "44"
        },
        {
            "x": "100",
            "y": "50"
        },
        {
            "x": "FD",
            "y": "57"
        },
        {
            "x": "F9",
            "y": "5E"
        },
        {
            "x": "F5",
            "y": "64"
        },
        {
            "x": "F2",
            "y": "6A"
        },
        {
            "x": "E9",
            "y": "76"
        },
        {
            "x": "E5",
            "y": "7C"
        },
        {
            "x": "E3",
            "y": "7E"
        },
        {
            "x": "FFFF",
            "y": "FFFF"
        },
        {
            "x": "138",
            "y": "2B"
        },
        {
            "x": "139",
            "y": "2D"
        },
        {
            "x": "13C",
            "y": "2E"
        },
        {
            "x": "13E",
            "y": "2E"
        },
        {
            "x": "140",
            "y": "2F"
        },
        {
            "x": "149",
            "y": "2F"
        },
        {
            "x": "151",
            "y": "2C"
        },
        {
            "x": "156",
            "y": "2A"
        },
        {
            "x": "158",
            "y": "28"
        },
        {
            "x": "15B",
            "y": "27"
        },
        {
            "x": "15D",
            "y": "25"
        },
        {
            "x": "15F",
            "y": "24"
        },
        {
            "x": "162",
            "y": "21"
        },
        {
            "x": "164",
            "y": "1D"
        },
        {
            "x": "166",
            "y": "19"
        },
        {
            "x": "163",
            "y": "15"
        },
        {
            "x": "15C",
            "y": "15"
        },
        {
            "x": "157",
            "y": "17"
        },
        {
            "x": "153",
            "y": "18"
        },
        {
            "x": "150",
            "y": "1A"
        },
        {
            "x": "14C",
            "y": "1B"
        },
        {
            "x": "145",
            "y": "20"
        },
        {
            "x": "141",
            "y": "22"
        },
        {
            "x": "136",
            "y": "2A"
        },
        {
            "x": "133",
            "y": "2E"
        },
        {
            "x": "12F",
            "y": "31"
        },
        {
            "x": "129",
            "y": "37"
        },
        {
            "x": "126",
            "y": "39"
        },
        {
            "x": "122",
            "y": "3F"
        },
        {
            "x": "121",
            "y": "42"
        },
        {
            "x": "11F",
            "y": "45"
        },
        {
            "x": "11D",
            "y": "4B"
        },
        {
            "x": "11D",
            "y": "50"
        },
        {
            "x": "11F",
            "y": "55"
        },
        {
            "x": "121",
            "y": "58"
        },
        {
            "x": "124",
            "y": "5A"
        },
        {
            "x": "126",
            "y": "5C"
        },
        {
            "x": "129",
            "y": "5E"
        },
        {
            "x": "130",
            "y": "60"
        },
        {
            "x": "135",
            "y": "60"
        },
        {
            "x": "139",
            "y": "61"
        },
        {
            "x": "13E",
            "y": "60"
        },
        {
            "x": "142",
            "y": "60"
        },
        {
            "x": "147",
            "y": "5E"
        },
        {
            "x": "14C",
            "y": "5D"
        },
        {
            "x": "FFFF",
            "y": "FFFF"
        },
        {
            "x": "17D",
            "y": "3B"
        },
        {
            "x": "179",
            "y": "3F"
        },
        {
            "x": "176",
            "y": "46"
        },
        {
            "x": "174",
            "y": "49"
        },
        {
            "x": "170",
            "y": "55"
        },
        {
            "x": "16E",
            "y": "59"
        },
        {
            "x": "16D",
            "y": "5C"
        },
        {
            "x": "16C",
            "y": "5F"
        },
        {
            "x": "16F",
            "y": "59"
        },
        {
            "x": "170",
            "y": "55"
        },
        {
            "x": "172",
            "y": "51"
        },
        {
            "x": "178",
            "y": "49"
        },
        {
            "x": "180",
            "y": "3D"
        },
        {
            "x": "185",
            "y": "38"
        },
        {
            "x": "189",
            "y": "33"
        },
        {
            "x": "198",
            "y": "24"
        },
        {
            "x": "19C",
            "y": "21"
        },
        {
            "x": "1A2",
            "y": "1B"
        },
        {
            "x": "1A8",
            "y": "17"
        },
        {
            "x": "1B0",
            "y": "14"
        },
        {
            "x": "1BB",
            "y": "14"
        },
        {
            "x": "FFFF",
            "y": "FFFF"
        },
        {
            "x": "1CB",
            "y": "3C"
        },
        {
            "x": "1CE",
            "y": "3B"
        },
        {
            "x": "1D0",
            "y": "3B"
        },
        {
            "x": "1D4",
            "y": "39"
        },
        {
            "x": "1DD",
            "y": "36"
        },
        {
            "x": "1E0",
            "y": "34"
        },
        {
            "x": "1E4",
            "y": "32"
        },
        {
            "x": "1E7",
            "y": "30"
        },
        {
            "x": "1EF",
            "y": "2C"
        },
        {
            "x": "1F2",
            "y": "2A"
        },
        {
            "x": "1F6",
            "y": "29"
        },
        {
            "x": "1FC",
            "y": "25"
        },
        {
            "x": "206",
            "y": "1B"
        },
        {
            "x": "208",
            "y": "18"
        },
        {
            "x": "208",
            "y": "16"
        },
        {
            "x": "209",
            "y": "12"
        },
        {
            "x": "207",
            "y": "10"
        },
        {
            "x": "201",
            "y": "10"
        },
        {
            "x": "1FE",
            "y": "11"
        },
        {
            "x": "1FA",
            "y": "13"
        },
        {
            "x": "1F7",
            "y": "15"
        },
        {
            "x": "1F2",
            "y": "17"
        },
        {
            "x": "1ED",
            "y": "1B"
        },
        {
            "x": "1E7",
            "y": "1E"
        },
        {
            "x": "1E2",
            "y": "21"
        },
        {
            "x": "1DD",
            "y": "25"
        },
        {
            "x": "1D5",
            "y": "2D"
        },
        {
            "x": "1D0",
            "y": "30"
        },
        {
            "x": "1C2",
            "y": "3E"
        },
        {
            "x": "1BF",
            "y": "42"
        },
        {
            "x": "1BB",
            "y": "4C"
        },
        {
            "x": "1BA",
            "y": "50"
        },
        {
            "x": "1BA",
            "y": "55"
        },
        {
            "x": "1BC",
            "y": "5F"
        },
        {
            "x": "1BE",
            "y": "64"
        },
        {
            "x": "1C0",
            "y": "68"
        },
        {
            "x": "1C3",
            "y": "6C"
        },
        {
            "x": "1C6",
            "y": "6F"
        },
        {
            "x": "1CE",
            "y": "73"
        },
        {
            "x": "1D3",
            "y": "74"
        },
        {
            "x": "1D8",
            "y": "74"
        },
        {
            "x": "FFFF",
            "y": "FFFF"
        }
    ],
    total: 100.16,
    attempts: 0,
}

export const PAYMENT_SCHEMA = {
    authorizationCode: null,
    pspCode: null,
    cardBrand: null,
    cardNumber: null,
    paymentDate: null,
    total: 0,
    attempts: 0,
}

export const PAYMENT_DEBT_SCHEMA = {
    totalDebt: 0,
    subtotal: 0,
    totalPaid: 0,
    currency: 'MXN',
    reservationCode: ''
}

export const GENERIC_PAYMENT_SCHEMA = {
    authorizationCode: null,
    paymentSystemReference:  null,
    paymentDate:  null,
    cardBrand: null,
    amount: null,
    signaturePoint: null,
    attempts: 0,
}
